import { VinScannerUiResult, mapRTUUIResult, withSBErrorHandling, } from '../types';
import { ScanbotSDKPlugin } from './Definitions';
/**
 * @internal
 * @hidden
 */
export const ScanbotVinImpl = {
    async startScanner(configuration) {
        return withSBErrorHandling(async () => mapRTUUIResult(await ScanbotSDKPlugin.startVinScanner(configuration), VinScannerUiResult));
    },
    async forceCloseScanner() {
        return withSBErrorHandling(ScanbotSDKPlugin.forceCloseVinScanner);
    },
};
//# sourceMappingURL=VinImpl.js.map